import AbuSimbel from "@/roc/wonders/ancientWorld/AbuSimbel";
import CheopsPyramid from "@/roc/wonders/ancientWorld/CheopsPyramid";
import ColossusOfRhodes from "@/roc/wonders/ancientWorld/ColossusOfRhodes";
import GreatWall from "@/roc/wonders/greatEmpire/GreatWall";
import GreatSphinx from "@/roc/wonders/ancientWorld/GreatSphinx";
import HangingGardens from "@/roc/wonders/ancientWorld/HangingGardens";
import LightHouseOfAlexandria from "@/roc/wonders/ancientWorld/LightHouseOfAlexandria";
import StatueOfZeus from "@/roc/wonders/ancientWorld/StatueOfZeus";
import Stonehenge from "@/roc/wonders/ancientWorld/Stonehenge";
import TempleOfArtemis from "@/roc/wonders/ancientWorld/TempleOfArtemis";
import TombOfMausolus from "@/roc/wonders/ancientWorld/TombOfMausolus";
import ChichenItza from "@/roc/wonders/greatEmpire/ChichenItza";
import Colosseum from "@/roc/wonders/greatEmpire/Colosseum";
import ForbiddenCity from "@/roc/wonders/greatEmpire/ForbiddenCity";
import HagiaSophia from "@/roc/wonders/greatEmpire/HagiaSophia";
import PalaceOfAachen from "@/roc/wonders/greatEmpire/PalaceOfAachen";
import SayilPalace from "@/roc/wonders/greatEmpire/SayilPalace";
import SherwoodForest from "@/roc/wonders/greatEmpire/SherwoodForest";
import TerracottaArmy from "@/roc/wonders/greatEmpire/TerracottaArmy";
import Tikal from "@/roc/wonders/greatEmpire/Tikal";
import CiteDeCarcassonne from "@/roc/wonders/storiesAndMyths/CiteDeCarcassonne";
import LeaningTowerOfPisa from "@/roc/wonders/storiesAndMyths/LeaningTowerOfPisa";
import Alhambra from "@/roc/wonders/storiesAndMyths/Alhambra";
import Yggdrasil from "@/roc/wonders/storiesAndMyths/Yggdrasil";
import Valhalla from "@/roc/wonders/storiesAndMyths/Valhalla";
import DragonShipEllida from "@/roc/wonders/storiesAndMyths/DragonShipEllida";
import Petra from '@/roc/wonders/storiesAndMyths/Petra';
import CityOfBrass from '@/roc/wonders/storiesAndMyths/CityOfBrass';
const Wonders = [
    Stonehenge,
    HangingGardens,
    StatueOfZeus,
    TempleOfArtemis,
    LightHouseOfAlexandria,
    TombOfMausolus,
    ColossusOfRhodes,
    CheopsPyramid,
    GreatSphinx,
    AbuSimbel,
    HagiaSophia,
    Colosseum,
    PalaceOfAachen,
    SherwoodForest,
    TerracottaArmy,
    ForbiddenCity,
    GreatWall,
    SayilPalace,
    Tikal,
    ChichenItza,
    CiteDeCarcassonne,
    LeaningTowerOfPisa,
    Alhambra,
    Yggdrasil,
    Valhalla,
    DragonShipEllida,
    Petra,
    CityOfBrass,
];
for (let i = 0; i < Wonders.length; i++) {
    if (Wonders[i].synergies.length > 0) {
        for (let j = 0; j < Wonders[i].synergies.length; j++) {
            Wonders[i].synergies[j].mod = Wonders[i].synergies[j].mod.withWonderId(Wonders[i].id);
            const eff = Wonders[i].effects.getEffect(Wonders[i].synergies[j].effectIndex);
            Wonders[i].synergies[j].effect = Wonders[i].synergies[j].mod.toEffect(eff);
        }
    }
}
export default Wonders;
